import { useEffect } from "react";
import { useState } from "react";
import Loader from "../../components/Loader/Loader";
import { useDispatch, useSelector } from 'react-redux';
import MyRolePlayPageSection from "../../components/RolePlay/MyRolePlayPageSection";
import CONFIG from '../../utils/config';
import { loginBrokerResponse } from '../../redux/auth/actions';
import { getBrandDetails, setUserRole, userDetailBroker } from '../../redux/user/actions';
import $ from "jquery";
import { applyTheme, clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";

const MyRolePlayMobile = () => {

    const dispatch = useDispatch()

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const key = params.get('key');
    const username = params.get('username');
    const user_id = params.get('user_id');
    const email = params.get('email');
    const color_1 = params.get('color_1');
    const color_2 = params.get('color_2');
    const role = params.get('role');
    const apply_theme = params.get('apply_theme');

    const userBranding = useSelector(state => state.user.userBranding);
    const [isLoading, setIsLoading] = useState(true)
    const [isValidKey, setIsValidKey] = useState(false)

    useEffect(() => {
        if (document.getElementById("id_page_404") !== null) {
        document.getElementById("id_page_404").style.display = "none";
        }
    }, [])

    useEffect(() => {
        console.log('Branding Data', userBranding)
        if (!_.isEmpty(userBranding)) {
            const branding = userBranding.payload.payload;
            if (!_.isEmpty(branding)) {
                applyTheme(branding)
            }
        }
    }, [userBranding])

    useEffect(() => {
        console.log('key', params.get('key'))
        if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
            $('html').css("--color-element-1", color_1 ? '#' + color_1 : CONFIG.COLOR_ELEMENT_1);
            $('html').css("--color-element-2", color_2 ? '#' + color_2 : CONFIG.COLOR_ELEMENT_2);
            localStorage.setItem(SessionKeys.API_TOKEN_BROKER, token);
            localStorage.setItem(SessionKeys.USERNAME, username);
            setIsValidKey(true)
            dispatch(setUserRole(role))
            if (apply_theme === "true") {
                dispatch(getBrandDetails({
                    module: "getUserBrandingData",
                    postData: {
                        token: token
                    }
                }))
            }
            dispatch(loginBrokerResponse({
                payload: {
                    user: {
                        user_id: user_id,
                        username: username,
                        role: [role],
                        email: email,
                        branding_primary_color_1: color_1 ? color_1 : CONFIG.COLOR_ELEMENT_1,
                        branding_primary_color_2: color_2 ? color_2 : CONFIG.COLOR_ELEMENT_2,
                        apply_theme: apply_theme === 'true' ? true : false
                    },
                    apiToken: token
                }
            }))
            dispatch(
                userDetailBroker({
                    module: "getOrderDetailBroker",
                    apiToken: token,
                })
            );
            clickStreamUser('roleplay_mobile_page', {
                userId: user_id,
            })
        }
    }, [token, key, user_id, dispatch])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            { isValidKey ?
                <>
                    <Loader start={isLoading} />
                    <MyRolePlayPageSection 
                        setIsLoading={setIsLoading}
                        isLoading={isLoading}
                        isMobile={true}
                    />
                </>
            :
                <div>
                    Invalid Key
                </div>
            }
        </>
    )
}

export default MyRolePlayMobile